<template>
  <div id="app">
    <router-view />
    <FoodTrends :data="content[locality]" :locality="locality" />
  </div>
</template>

<script>
import FoodTrends from './pages/FoodTrends.vue'
import Content from './data/content'

export default {
  name: 'App',
  components: { FoodTrends },
  data() {
    return {
      locality: process.env.VUE_APP_LOCALITY,
      content: Content,
    }
  },
}
</script>

<style lang="scss">
$desktop: 1440px;
$tablet: 768px;
$mobile: 600px;

@font-face {
  font-family: JETSans-Bold;
  src: url('./assets/fonts/jet-sans/JETSans-Bold.otf') format('opentype');
}
@font-face {
  font-family: JETSans-BoldItalic;
  src: url('./assets/fonts/jet-sans/JETSans-BoldItalic.otf') format('opentype');
}
@font-face {
  font-family: JETSans-ExtraBold;
  src: url('./assets/fonts/jet-sans/JETSans-ExtraBold.otf') format('opentype');
}
@font-face {
  font-family: JETSans-Italic;
  src: url('./assets/fonts/jet-sans/JETSans-Italic.otf') format('opentype');
}
@font-face {
  font-family: JETSans-Regular;
  src: url('./assets/fonts/jet-sans/JETSans-Regular.otf') format('opentype');
}

body {
  padding: 0;
  margin: 0;
}

#app {
  --color-orange-1: rgb(255, 128, 0);
  --color-white-1: rgb(255, 255, 255);
  --color-mozzarella-4: rgb(234, 231, 228);
  --color-mozzarella-3: rgb(250, 250, 250);
  --color-mozzarella-2: rgb(245, 243, 241);
  --color-mozzarella-1: rgb(239, 237, 234);
  --color-charcoal-1: rgb(36, 46, 48);
  --color-aubergine-1: rgb(91, 61, 91);
  --color-tumeric-1: rgb(246, 194, 67);
  --color-berry-1: rgb(242, 166, 176);
  --color-cupcake-1: rgb(193, 218, 222);
  --color-tomato-1: rgb(247, 94, 40);
  --color-grey-1: rgb(229, 229, 229);

  padding: 0;
  margin: 0;
  width: 100%;
  overflow-x: hidden;
  font-family: 'JETSans-Bold', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

h1,
h2,
h3,
h4 {
  font-family: 'JETSans-ExtraBold', sans-serif;
  font-weight: 900;
  text-transform: none;
}
h1 {
  font-size: 60px;
  line-height: 60px;
  @media (max-width: $tablet) {
    font-size: 50px;
    line-height: 50px;
  }
  @media (max-width: $desktop) {
    font-size: 50px;
    line-height: 50px;
  }
}
h2 {
  font-size: 50px;
  line-height: 50px;
  @media (max-width: $tablet) {
    font-size: 40px;
    line-height: 40px;
  }
  @media (max-width: $desktop) {
    font-size: 40px;
    line-height: 40px;
  }
}
h3 {
  font-size: 40px;
  line-height: 40px;
  @media (max-width: $tablet) {
    font-size: 30px;
    line-height: 30px;
  }
  @media (max-width: $desktop) {
    font-size: 30px;
    line-height: 30px;
  }
}
h4 {
  font-size: 30px;
  line-height: 35px;
  @media (max-width: $tablet) {
    font-size: 20px;
    line-height: 25px;
  }
  @media (max-width: $desktop) {
    font-size: 20px;
    line-height: 25px;
  }
}
p,
span,
li {
  font-size: 22px;
  font-family: 'JETSans-Regular', sans-serif;
  @media (max-width: $tablet) {
    font-size: 14px;
  }
  @media (max-width: $desktop) {
    font-size: 18px;
  }
}
button {
  font-family: 'JETSans-Bold', sans-serif;
  min-width: 200px;
  padding: 15px;
  border-radius: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  @media (max-width: $tablet) {
    font-size: 12px;
    padding: 10px;
    min-width: 140px;
  }
}
</style>
